module.exports = __webpack_public_path__ + "static/media/SM Ride hailing.146832d7.svg";